module.exports = __webpack_public_path__ + "img/fondo_newepisodios.107c04fb.jpg";